// extracted by mini-css-extract-plugin
module.exports = {"Input":"styles_Input__CkdCc"};